import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import vAdminformat from "../adminFormat";
import { Link } from 'react-router-dom';
import config from '../config';
import { headers } from '../token';
import validateError from '../ValidateError';


const server_backend = config.API_URL;

const XeroAuth = () => {

    const [lastCode, SetLastCode] = useState([]);
    const [authXeroModal, setAutXeroModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showHelModal, setShowHelpModal] = useState(false);


    const [formData, setFormData] = useState({
        clientId: '',
        clientSecret: '',
        urlRedirect: '',
        accessToken: '',
        tenantId: '',
        lastlogin: '',
    });

    const [status, setStatus] = useState([]);

    useEffect(() => {
        async function fetchStatus() {
            setLoading(true);
            try {
                const response = await axios.get(`${server_backend}/api/xero/status`, headers);

                setStatus(response.data.RES_RESULT);
            } catch (error) {
                console.log("Unexpected error, please check")
            }
            finally {
                setLoading(false);
            }
        }

        fetchStatus();
    }, []); // It runs once when the component is mounted









    useEffect(() => {
        async function fetchCompany() {
            try {
                const response = await axios.get(`${server_backend}/api/getClientConfig`, headers);
                //console.log("Unexpected error, please check")





                SetLastCode(response.data.RES_RESULT);
                //setFormData({ ...formData, urlRedirect: response.data.urlRedirect, lastlogin: response.data.last_login });






            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }

        fetchCompany();
    }, []);

    async function fetchCompany() {
        try {
            const response = await axios.get(`${server_backend}/api/getClientConfig`, headers);

            SetLastCode(response.data.RES_RESULT);
            //console.log("Unexpected error, please check")
            //setFormData({ ...formData, urlRedirect: response.data.urlRedirect, lastlogin: response.data.last_login });





        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }


    async function fetchStatus() {
        try {
            setLoading(true);
            const response = await axios.get(`${server_backend}/api/xero/status`, headers);
            //console.log("Unexpected error, please check")





            setStatus(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        } finally {
            setLoading(false);
        }
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const redirectToXeroAuth = () => {

        if (!lastCode.clientId || !lastCode.urlRedirect || !lastCode.clientSecret) {
            Swal.fire({
                icon: 'error',
                title: 'Missing Configuration',
                text: 'Please ensure Client ID, URL Redirect, and Client Secret are configured correctly.',
            });
            return;
        }

        const scope = 'openid profile email accounting.transactions accounting.settings offline_access';

        const xeroAuthUrl = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${lastCode.clientId}&redirect_uri=${lastCode.urlRedirect}&scope=${scope}`;
        //console.log("Unexpected error, please check")








        window.location.href = xeroAuthUrl;
    };


    const loginXero = async (code) => {
        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/api/xero/authenticate`, {
                code,
                urlRedirect: lastCode.urlRedirect,
            }, headers);
            console.log("Unexpected error, please check")
        } catch (error) {
            validateError(error);
        } finally {
            setLoading(false);
            getItemsFromXero();
            fetchStatus();
        }
    };

    const saveData = async () => {
        // Validate if the fields are complete




        if (!formData.clientId || !formData.clientSecret || !formData.urlRedirect) {
            Swal.fire({
                icon: 'error',
                title: 'Missing Parameters',
                text: 'Please complete all required fields before saving.',
                confirmButtonText: 'Ok'
            });
            return; // Get out of the function if data are missing



        }

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this information?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const response = await axios.post(`${server_backend}/api/xero/saveCompanyData`, {
                        clientId: formData.clientId,
                        clientSecret: formData.clientSecret,
                        urlRedirect: formData.urlRedirect,
                    }, headers);

                    if (response.data.RES_CODE === '00') {
                        Swal.fire({
                            icon: 'success',
                            title: 'Saved Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        setShowPopover(true);
                    }

                } catch (error) {
                    validateError(error);
                } finally {
                    setAutXeroModal(false);
                    setTimeout(() => {
                        fetchStatus();
                        fetchCompany();
                        setLoading(false);
                    }, 2000);

                }
            }
        });
    };

    useEffect(() => {
        const code = new URLSearchParams(window.location.search).get('code');
        if (code && lastCode.clientId) {
            loginXero(code);
        }
    }, [lastCode]);

    const OpenhelpModal = () => {
        setShowHelpModal(true);
    }

    const closeHelpModal = () => {
        setShowHelpModal(false);
    }

    const [showPopover, setShowPopover] = useState(false);
    const authButtonRef = useRef(null);
    let popoverInstance = null;

    useEffect(() => {
        if (showPopover && authButtonRef.current) {
            // eslint-disable-next-line no-undef





            popoverInstance = new window.bootstrap.Popover(authButtonRef.current, {
                content: 'Once saved, click here to start the authentication process with Xero.',
                placement: 'top',
                trigger: 'manual',
                container: 'body',
                animation: true,
            });
            popoverInstance.show();
        }

        const timer = setTimeout(() => {
            if (popoverInstance) {
                popoverInstance.hide();
            }
        }, 10000);

        return () => {
            clearTimeout(timer);
            if (popoverInstance) {
                popoverInstance.dispose();
            }
        };
    }, [showPopover]);




    const [showMaterialsModal, setShowMaterialsModal] = useState(false);
    const [MaterialList, setMaterialList] = useState([]);
    const [ProductList, setProductList] = useState([]);
    const [xeroItemList, setXeroItemList] = useState([]);


    useEffect(() => {
        const getItemsFromXero = async () => {
            try {
                const response = await axios.get(`${server_backend}/api/getitems`, headers);
                //console.log("Unexpected error, please check")



                if (response.data.RES_CODE === "00") {
                    const items = response.data.RES_RESULT.items;
                    console.log("Unexpected error, please check")
                    setXeroItemList(items);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getItemsFromXero();
    }, []);


    /*  useEffect(() => {
         const getMaterial = async () => {
             try {
                 const response = await axios.get(`${server_backend}/materials/list`, headers);
                 if (response.data.RES_CODE === "00") {
                     const materials = response.data.RES_RESULT;
 
                     //Create a new arrangement with the existsinxero field
 
                     const materialsWithXeroStatus = materials.map(material => {
                         //We verify if the material exists in xero comparing material.comment with xeritemlist.code
 
                         const exists = xeroItemList.some(xeroItem => xeroItem.code === material.comment);
                         return {
                             ...material,
                             existsInXero: exists //TRUE THE FALSE
 
                         };
                     });
 
 
                     setMaterialList(materialsWithXeroStatus);
                 }
             } catch (error) {
                 console.log("Unexpected error, please check")
             }
         }
         getMaterial();
     }, [xeroItemList]);
  */

    const [loadingIds, setLoadingIds] = useState([]);

    const getItemsFromXero = async () => {
        try {
            const response = await axios.get(`${server_backend}/api/getitems`, headers);
            //console.log("Unexpected error, please check")



            if (response.data.RES_CODE === "00") {
                const items = response.data.RES_RESULT.items;

                setXeroItemList(items);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const getMaterial = async () => {
        try {
            const response = await axios.get(`${server_backend}/materials/list`, headers);
            if (response.data.RES_CODE === "00") {
                const materials = response.data.RES_RESULT;

                // Create a new arrangement with the existsinxero field



                const materialsWithXeroStatus = materials.map(material => {
                    // We verify if the material exists in xero comparing material.comment with xeritemlist.code



                    const exists = xeroItemList.some(xeroItem => xeroItem.code === material.comment);
                    return {
                        ...material,
                        existsInXero: exists // TRUE THE FALSE



                    };
                });


                setMaterialList(materialsWithXeroStatus);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const getProducts = async () => {
        try {
            const response = await axios.get(`${server_backend}/products/list`, headers);
            if (response.data.RES_CODE === "00") {
                const products = response.data.RES_RESULT;

                // Create a new arrangement with the existsinxero field



                const productsWithXeroStatus = products.map(product => {
                    // We verify if the product exists in xero comparing product.comment with xeritemlist.code



                    const exists = xeroItemList.some(xeroItem => xeroItem.code === product.comment);
                    return {
                        ...product,
                        existsInXero: exists // TRUE THE FALSE



                    };
                });


                setProductList(productsWithXeroStatus);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }


    const OpenMaterialsModal = () => {
        getProducts();
        getMaterial();
        setShowMaterialsModal(true);
    }

    const closeMaterialsModal = () => {
        setShowMaterialsModal(false);
    }

    const createItemInXero = async (item) => {
        if (!item.comment || item.comment.trim() === '') {
            Swal.fire({
                icon: "error",
                title: "Missing Xero Code",
                text: "Please ensure the item has a Xero code before syncing.",
                confirmButtonText: "Ok"
            });
            return;
        }

        // Detect if it is material or product

        const isMaterial = !!item.mat_ID;
        const itemId = isMaterial ? item.mat_ID : item.pto_ID;

        try {
            setLoadingIds((prev) => [...prev, itemId]);

            const response = await axios.post(
                `${server_backend}/api/xero/createitem`,
                {
                    name: item.name,
                    code: item.comment,
                    description: item.description,
                    purchasePrice: 50,
                    salesPrice: 120,
                    isTrackedAsInventory: true,
                },
                headers
            );

            if (response.data.RES_CODE === "00") {
                if (isMaterial) {
                    // Update materials

                    setMaterialList((prevList) =>
                        prevList.map((m) =>
                            m.mat_ID === itemId ? { ...m, existsInXero: true } : m
                        )
                    );
                } else {
                    // Update products

                    setProductList((prevList) =>
                        prevList.map((p) =>
                            p.pto_ID === itemId ? { ...p, existsInXero: true } : p
                        )
                    );
                }
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        } finally {
            setLoadingIds((prev) => prev.filter((id) => id !== itemId));
        }
    };



    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div>
                <div className="card-header">
                    <div className="d-flex justify-content-end">
                        <div className="flex-grow-1">
                            <center><h5>Xero server</h5></center>
                        </div>
                    </div>
                    <div className="flex-grow-1 d-flex align-items-center justify-content-between">
                        <h5 className="mb-0">
                            Last Login: <Link>{vAdminformat.FormatDate(formData.lastlogin)}</Link>
                        </h5>
                        <div className="hstack gap-2">

                            {status?.authStatus?.step === 'success'
                                && (
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={OpenMaterialsModal}
                                        title="View instructions"
                                    >
                                        <i className="ri-question-line me-1"></i> Material Match
                                    </button>
                                )}


                            <button
                                type="button"
                                className="btn btn-info"
                                onClick={OpenhelpModal}
                                title="View instructions"
                            >
                                <i className="ri-question-line me-1"></i> Help
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setAutXeroModal(true)}
                            >
                                <i className="ri-settings-3-line"></i>
                            </button>

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={redirectToXeroAuth}
                                ref={authButtonRef}
                            >
                                Start Authentication
                            </button>
                        </div>
                    </div>

                </div>
                <div className="col-12 card card-body" style={{ minHeight: "90vh" }}>
                    <div className="col-lg-12">
                        <div className="card pricing-box ribbon-box ribbon-fill text-center">
                            <div className="ribbon ribbon-primary">Xero</div>
                            <div className="row g-0">
                                <div className="col-12">
                                    <div className="card-body h-100">
                                        <div>
                                            <p className="text-muted">
                                                Your Client ID and Client Secret is used to authenticate your application with Xero.
                                                Do not share it with anyone.
                                            </p>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <div className="card-body pb-0">
                                                    <ul className="list-unstyled vstack gap-3 mb-0">

                                                        {loading ? (

                                                            <>
                                                                <li className="d-flex justify-content-between align-items-center placeholder-glow">
                                                                    <span className="placeholder placeholder-lg col-6"></span>
                                                                    <span className="placeholder placeholder-lg col-3"></span>
                                                                </li>
                                                                <li className="d-flex justify-content-between align-items-center placeholder-glow">
                                                                    <span className="placeholder placeholder-lg col-6"></span>
                                                                    <span className="placeholder placeholder-lg col-3"></span>
                                                                </li>
                                                                <li className="d-flex justify-content-between align-items-center placeholder-glow">
                                                                    <span className="placeholder placeholder-lg col-6"></span>
                                                                    <span className="placeholder placeholder-lg col-3"></span>
                                                                </li>
                                                                <li className="d-flex justify-content-between align-items-center placeholder-glow">
                                                                    <span className="placeholder placeholder-lg col-6"></span>
                                                                    <span className="placeholder placeholder-lg col-3"></span>
                                                                </li>
                                                                <li className="d-flex justify-content-between align-items-center placeholder-glow">
                                                                    <span className="placeholder placeholder-lg col-6"></span>
                                                                    <span className="placeholder placeholder-lg col-3"></span>
                                                                </li>
                                                                <li className="d-flex justify-content-between align-items-center placeholder-glow">
                                                                    <span className="placeholder placeholder-lg col-6"></span>
                                                                    <span className="placeholder placeholder-lg col-3"></span>
                                                                </li>

                                                            </>
                                                        ) : (
                                                            // 🔹 Real content



                                                            <>
                                                                <li className="d-flex justify-content-between align-items-center">
                                                                    <span>Status:</span>
                                                                    <i
                                                                        style={{ fontSize: "28px" }}
                                                                        className={`fa ${status?.authStatus?.step === 'success'
                                                                            ? 'ri-checkbox-circle-line text-success'
                                                                            : null
                                                                            }`}
                                                                    ></i>
                                                                    {status?.authStatus?.step === 'error' && (
                                                                        <label className="text-danger">{status.authStatus.message}</label>
                                                                    )}
                                                                </li>

                                                                <li className="d-flex justify-content-between align-items-center">
                                                                    <span>Client ID:</span>
                                                                    <i
                                                                        style={{ fontSize: "28px" }}
                                                                        className={`fa ${status?.ClientStatus?.step === 'success'
                                                                            ? 'ri-checkbox-circle-line text-success'
                                                                            : null
                                                                            }`}
                                                                    ></i>
                                                                    {status?.ClientStatus?.step === 'error' && (
                                                                        <label className="text-danger">{status.ClientStatus.message}</label>
                                                                    )}
                                                                </li>

                                                                <li className="d-flex justify-content-between align-items-center">
                                                                    <span>Client Secret:</span>
                                                                    <i
                                                                        style={{ fontSize: "28px" }}
                                                                        className={`fa ${status?.clientSecret?.step === 'success'
                                                                            ? 'ri-checkbox-circle-line text-success'
                                                                            : null
                                                                            }`}
                                                                    ></i>
                                                                    {status?.clientSecret?.step === 'error' && (
                                                                        <label className="text-danger">{status.clientSecret.message}</label>
                                                                    )}
                                                                </li>

                                                                <li className="d-flex justify-content-between align-items-center">
                                                                    <span>Company or application URL:</span>
                                                                    <i
                                                                        style={{ fontSize: "28px" }}
                                                                        className={`fa ${status?.UrlRedirect?.step === 'success'
                                                                            ? 'ri-checkbox-circle-line text-success'
                                                                            : null
                                                                            }`}
                                                                    ></i>
                                                                    {status?.UrlRedirect?.step === 'error' && (
                                                                        <label className="text-danger">{status.UrlRedirect.message}</label>
                                                                    )}
                                                                </li>
                                                            </>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* end row */}
                        </div>
                    </div>
                </div>

            </div>
            <div
                className={`modal fade ${authXeroModal ? "show" : ""}`}
                style={{ display: authXeroModal ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-danger" id="myExtraLargeModalLabel">
                                Important: Client ID and Client Secret are access credentials. Do not share them.
                            </h5>
                            <Link className="btn-close" onClick={() => setAutXeroModal(false)} aria-label="Close"></Link>
                        </div>
                        <div className="modal-body">
                            <div className="row g-4 p-3">
                                <div className="col-6">
                                    <label className="form-label">Client ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="clientId"
                                        value={formData.clientId}
                                        onChange={handleChange}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-6">
                                    <label className="form-label">Client Secret</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="clientSecret"
                                        value={formData.clientSecret}
                                        onChange={handleChange}
                                        autoComplete="off"

                                    />
                                </div>
                                <div className="col-12 mt-2">
                                    <label className="form-label">Company or application URL</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="urlRedirect"
                                        value={formData.urlRedirect}
                                        onChange={handleChange}
                                        autoComplete="off"

                                    />
                                </div>
                            </div>

                            {/* Buttons at the foot */}
                            <div className="d-flex justify-content-end mt-4">
                                <Link type="button" className="btn btn-danger me-2" onClick={() => setAutXeroModal(false)}>
                                    Discard
                                </Link>
                                <button
                                    type="button"
                                    onClick={saveData}
                                    className="btn btn-secondary waves-effect waves-light"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`modal fade ${showHelModal ? "show" : ""}`}
                style={{ display: showHelModal ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-danger" id="myExtraLargeModalLabel">
                                Important: Client ID and Client Secret are access credentials. Do not share them.
                            </h5>
                            <Link className="btn-close" onClick={closeHelpModal} aria-label="Close"></Link>
                        </div>
                        <div className="modal-body">
                            <h5 className="fw-semibold mb-3">
                                <i className="ri-information-line align-middle me-2 text-primary"></i>
                                Xero Integration Instructions
                            </h5>

                            <ul className="list-unstyled">
                                <li className="mb-3">
                                    <i className="ri-key-line text-success me-2 fs-5"></i>
                                    <strong>Client ID:</strong> This is a unique identifier provided by Xero when you create your application in the <a href="https://developer.xero.com/" target="_blank" rel="noopener noreferrer">Xero Developer Portal</a>. You can find it in your app’s settings under “Configuration”.
                                </li>
                                <li className="mb-3">
                                    <i className="ri-lock-password-line text-warning me-2 fs-5"></i>
                                    <strong>Client Secret:</strong> This is your private key, used along with the Client ID to securely connect your system with Xero. Keep it confidential.
                                </li>
                                <li className="mb-3">
                                    <i className="ri-link-m text-info me-2 fs-5"></i>
                                    <strong>Company or Application URL:</strong> This should be the main URL of your application (e.g., <code>https://yourcompany.com</code>) that was registered in your Xero app settings. It’s used to verify and redirect during authentication.
                                </li>
                            </ul>

                            <div className="alert alert-info d-flex align-items-start mt-4">
                                <i className="ri-lightbulb-flash-line fs-4 me-2 text-primary"></i>
                                <div>
                                    Once all fields are completed correctly, click <strong>Start Authentication</strong> to securely connect your system with Xero. After successful authentication, you will be able to send job invoices directly to Xero.
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div
                className={`modal fade ${showMaterialsModal ? "show" : ""}`}
                style={{ display: showMaterialsModal ? "block" : "none", backgroundColor: "rgba(0,0,0,0.6)" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content border-0 shadow-lg rounded-4">

                        {/* Header */}
                        <div className="modal-header py-3 px-4 rounded-top-4 bg-dark text-white">
                            <h5 className="modal-title w-100 text-center fs-5 fw-bold text-white">Xero Material & Product Overview</h5>
                            <button className="btn-close btn-close-white" onClick={closeMaterialsModal} aria-label="Close"></button>
                        </div>

                        {/* Body */}
                        <div
                            className="modal-body card p-4"
                            style={{
                                minHeight: "80vh",
                                maxHeight: "80vh",
                                overflowY: "auto",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "0 0 1rem 1rem"
                            }}
                        >

                            {/* Material Section */}
                            <div className="mb-5">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="text-primary fw-bold mb-0">
                                        <i className="bi bi-droplet me-2"></i> Material List
                                    </h5>
                                    {/*  <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => console.log("Sync all materials not in Xero")}
            >
              Sync All Missing
            </button> */}
                                </div>

                                <div className="table-responsive shadow-sm border rounded-3">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light text-muted">
                                            <tr>
                                                <th className="py-2">Name</th>
                                                <th className="py-2">Xero Code</th>
                                                <th className="py-2">Exists in Xero</th>
                                                <th className="py-2">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {MaterialList.map((material) => (
                                                <tr key={material.mat_ID} className="align-middle">
                                                    <td className='w-50'>
                                                        <span
                                                            style={{
                                                                width: "16px",
                                                                height: "16px",
                                                                backgroundColor: material.color || "#cccccc",
                                                                borderRadius: "50%",
                                                                border: "1px solid #aaa",
                                                                display: "inline-block",
                                                                marginRight: "10px",
                                                            }}
                                                        ></span>
                                                        <span className="fw-medium">{material.name}</span>
                                                    </td>
                                                    <td>{material.comment}</td>
                                                    <td>
                                                        <span
                                                            className={`badge ${material.existsInXero ? "bg-success" : "bg-danger"} text-white py-1 px-2`}
                                                        >
                                                            {material.existsInXero ? "Yes" : "No"}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <button
                                                            className={`btn btn-sm ${material.existsInXero ? "btn-outline-secondary" : "btn-secondary"} px-3`}
                                                            disabled={material.existsInXero || loadingIds.includes(material.mat_ID)}
                                                            onClick={() => createItemInXero(material)}
                                                            style={{ minWidth: "120px" }}
                                                        >
                                                            {loadingIds.includes(material.mat_ID)
                                                                ? "Loading..."
                                                                : material.existsInXero
                                                                    ? "Exists"
                                                                    : "Create in Xero"}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Product Section */}
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="text-success fw-bold mb-0">
                                        <i className="bi bi-box-seam me-2"></i> Product List
                                    </h5>
                                    {/* <button
              type="button"
              className="btn btn-sm btn-outline-success"
              onClick={() => console.log("Sync all products not in Xero")}
            >
              Sync All Missing
            </button> */}
                                </div>

                                <div className="table-responsive shadow-sm border rounded-3">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light text-muted">
                                            <tr>
                                                <th className="py-2">Name</th>
                                                <th className="py-2">Xero Code</th>
                                                <th className="py-2">Exists in Xero</th>
                                                <th className="py-2">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ProductList.map((product) => (
                                                <tr key={product.pto_ID} className="align-middle">
                                                    <td className='w-50'>
                                                        <span
                                                            style={{
                                                                width: "16px",
                                                                height: "16px",
                                                                backgroundColor: product.color || "#cccccc",
                                                                borderRadius: "50%",
                                                                border: "1px solid #aaa",
                                                                display: "inline-block",
                                                                marginRight: "10px",
                                                            }}
                                                        ></span>
                                                        <span className="fw-medium">{product.name}</span>
                                                    </td>
                                                    <td>{product.comment}</td>
                                                    <td>
                                                        <span
                                                            className={`badge ${product.existsInXero ? "bg-success" : "bg-danger"} text-white py-1 px-2`}
                                                        >
                                                            {product.existsInXero ? "Yes" : "No"}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <button
                                                            className={`btn btn-sm ${product.existsInXero ? "btn-outline-secondary" : "btn-secondary"} px-3`}
                                                            disabled={product.existsInXero || loadingIds.includes(product.pto_ID)}
                                                            onClick={() => createItemInXero(product)}
                                                            style={{ minWidth: "120px" }}
                                                        >
                                                            {loadingIds.includes(product.pto_ID)
                                                                ? "Loading..."
                                                                : product.existsInXero
                                                                    ? "Exists"
                                                                    : "Create in Xero"}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Footer Buttons */}
                            <div className="d-flex justify-content-end mt-4">
                                <button type="button" className="btn btn-danger me-2 px-4" onClick={closeMaterialsModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        </div>
    );
};

export default XeroAuth;
